import { Localized, useLocalization } from '@fluent/react';
import { Textarea } from '@vechaiui/react';

import ContactPointForm from '#/components/forms/ContactPointForm';
import FieldArray from '#/components/forms/FieldArray';
import Fieldset from '#/components/forms/Fieldset';
import OfferForm from '#/components/forms/OfferForm';
import PostalAddressForm from '#/components/forms/PostalAddressForm';
import { InputFormik } from '#/components/controls/Input';
import { MalaysiaStateCheckboxGroupFormik } from '#/components/controls/MalaysiaStateCheckboxGroup';

const LogisticsSignupForm = () => {
  const { l10n } = useLocalization();

  return (
    <div className="divide-y">
      <div className="space-y-6 pb-8">
        <Localized id="organization-name" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('organization-name')} name="name" />
        </Localized>

        <Localized id="company-number" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('company-number')} name="companyNumber" />
        </Localized>

        <Localized id="organization-telephone" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('organization-telephone')} name="telephone" />
        </Localized>

        <PostalAddressForm name="address" />

        <Fieldset title={l10n.getString('offers')}>
          <FieldArray
            variant="compact"
            name="offers"
            initialValue={{ inventoryLevel: 1 }}
            label={l10n.getString('offer')}
          >
            {(formProps) => <OfferForm {...formProps} />}
          </FieldArray>
        </Fieldset>

        <Fieldset title={l10n.getString('areas-served')}>
          <MalaysiaStateCheckboxGroupFormik name="areasServed" />
        </Fieldset>

        <Fieldset title={`${l10n.getString('primary')} ${l10n.getString('person-in-charge')}`}>
          <ContactPointForm name="contactPoints.0" showLabel={false} />
        </Fieldset>

        <Fieldset title={`${l10n.getString('secondary')} ${l10n.getString('person-in-charge')}`}>
          <ContactPointForm name="contactPoints.1" showLabel={false} />
        </Fieldset>
      </div>

      <div className="space-y-6 pt-6">
        <Localized id="referral" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('referral')} name="referral" />
        </Localized>

        <Localized id="remark" attrs={{ placeholder: true }}>
          <InputFormik as={Textarea} label={l10n.getString('remark')} name="remark" />
        </Localized>
      </div>
    </div>
  );
};

export default LogisticsSignupForm;
